import { render, staticRenderFns } from "./BuyerRegistrationSettingsForm.vue?vue&type=template&id=1f6a1e5c"
import script from "./BuyerRegistrationSettingsForm.vue?vue&type=script&lang=js"
export * from "./BuyerRegistrationSettingsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports